import Carousel from "nuka-carousel";
import React from "react";
import { speacialtyListType } from ".";
import SPYellowLogo from "../SVGs/SPYellowLogo";
import { CtaButton } from "../Cta/cta-button";

type SpecialtyCarouselType = {
  specialtyList: speacialtyListType[];
  eyebrowText?: string;
  setIndexItemActive: (item: number) => void;
  clean: () => void;
  indexItemActive: number;
  executeAnimation: () => void;
  openInNewTab?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const SpecialtyCarousel: React.FC<SpecialtyCarouselType> = ({
  specialtyList,
  eyebrowText,
  setIndexItemActive,
  indexItemActive,
  clean,
  executeAnimation,
  openInNewTab,
  onClick,
}) => {
  const handleCarouselItem = (item: number) => {
    clean();
    setIndexItemActive(item);
    setTimeout(() => {
      executeAnimation();
    }, 100);
  };

  return (
    <div className="carousel--specialty">
      <div className="carousel--specialty__dots">
        <span className="text--carousel__eyebrow-text">{eyebrowText}</span>
        <div className="carousel--specialty__dots_wrapper">
          {Array.from(Array(specialtyList?.length).keys()).map(
            (item: number, key) => {
              return (
                <button
                  className="button-no-style"
                  type="button"
                  disabled={indexItemActive === item}
                  onClick={() => handleCarouselItem(item)}
                  key={key}
                >
                  <div
                    className={`carousel--specialty__dots_dot ${
                      indexItemActive === item && "isActive"
                    } `}
                  />
                </button>
              );
            }
          )}
        </div>
      </div>
      <div className="carousel--container">
        <SPYellowLogo yellowLogoPosition={-15} className="sp-yellow-mobile" />
        <Carousel
          slideIndex={indexItemActive}
          renderCenterLeftControls={null}
          renderCenterRightControls={null}
          renderCenterCenterControls={null}
          renderBottomRightControls={null}
          renderBottomCenterControls={null}
          dragging
          slidesToShow={1.23}
          beforeSlide={(_: any, b: number) => handleCarouselItem(b)}
          className="carousel--nuka"
        >
          {Array.from(Array(specialtyList?.length).keys()).map(
            (item: number, key) => {
              const specialty = specialtyList?.[item];

              const isActive = item === indexItemActive;

              return (
                <div
                  key={key}
                  className={`carousel--wrapper ${
                    !isActive && "carousel--wrapper-hidden"
                  } ${
                    item === specialtyList?.length - 1 &&
                    "carousel--wrapper-last"
                  }`}
                >
                  <h3
                    className={`text--carousel__options-title ${
                      isActive && "isActive"
                    }`}
                  >
                    {specialty?.title}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: specialty?.subCopy || "",
                    }}
                    className="text--carousel__copy-text"
                  />
                  <div className="mobile-cta-wrapper mobile-cta-carousel">
                    {specialty?.mobileCtaCopy && (
                      <CtaButton
                        copy={specialty?.mobileCtaCopy}
                        copySize="bodyRegular"
                        isDisabled={false}
                        link={specialty?.ctaLink?.value?.data?.url}
                        linkUrl={specialty?.ctaUrl || null}
                        variant="tertiarySun"
                        openInNewTab={specialty?.openInNewTab}
                        className="text--carousel--marketing-link cta--button-wrapper hasTertiary"
                        onClick={onClick}
                      />
                    )}
                  </div>
                </div>
              );
            }
          )}
        </Carousel>
      </div>
    </div>
  );
};
export default SpecialtyCarousel;
